import React from 'react';
import { useTranslation } from 'react-i18next';
import { DesktopFilterSelectAccordion } from './DesktopFilterSelectAccordion';
import { getSellerTypeOptions } from '@/components/Filters/helpers';
import { SearchResultsPageTestIds } from '@/__e2e__/testIds/search-results-page';
import { QUERY } from '@/constants/common';

type Props = {
  isShop: boolean | null;
  isLoading?: boolean;
};

export const SellerTypeDesktopFilter = ({ isShop, isLoading }: Props) => {
  const { t } = useTranslation();
  const options = getSellerTypeOptions(t, isShop);

  const {
    sellerType: sellerTypeTestId,
    sellerTypeOption: sellerTypeOptionTestId,
  } = SearchResultsPageTestIds.desktopFilters;
  const value = options.find(({ isSelected }) => isSelected)?.label ?? null;

  return (
    <DesktopFilterSelectAccordion
      isLoading={isLoading}
      dataTestId={sellerTypeTestId}
      queryParam={QUERY.isShop}
      title={t('common.seller_type')}
      value={value}
      options={options}
      optionTestId={sellerTypeOptionTestId}
    />
  );
};
